<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template #header>
            <h5 class="m-0">Respostas</h5>
          </template>
          <b-card-body>
            <div class="filters-section">
              <div>
                <b-button size="sm" variant="outline-secondary" @click="goBack">
                  <i class="fa fa-arrow-left mr-1"></i>
                  Voltar
                </b-button>
              </div>
              <div class="flex-grow-1"></div>
              <div class="action-button">
                <b-button
                  size="sm"
                  variant="primary"
                  @click="onNewResponseClicked"
                >
                  Nova Resposta
                </b-button>
              </div>
            </div>

            <div class="table-container">
              <b-table
                ref="table"
                :items="retrieveData"
                :fields="headers"
                thead-class="responses-header"
                :tbody-tr-class="rowClass"
                borderless
                hover
                responsive
                show-empty
              >
                <template #cell(id)="row">
                  <span class="id-text">{{ row.item._id }}</span>
                </template>
                <template #cell(text)="row">
                  <strong class="text-content">{{ row.item.text }}</strong>
                </template>
                <template #cell(actions)="row">
                  <b-button
                    size="sm"
                    variant="link"
                    class="action-button-icon mr-1"
                    title="Editar"
                    @click.stop="edit(row.item, row.index, $event.target)"
                  >
                    <i class="fa fa-edit action-icon" aria-hidden="true"></i>
                  </b-button>
                  <b-button
                    size="sm"
                    variant="link"
                    class="action-button-icon"
                    title="Apagar"
                    @click.stop="remove(row.item, row.index, $event.target)"
                  >
                    <i class="fa fa-trash action-icon" aria-hidden="true"></i>
                  </b-button>
                </template>

                <template #empty>
                  <div class="text-muted text-center py-5">
                    <i class="fas fa-comment fa-2x"></i>
                    <p class="mt-3">Nenhuma resposta cadastrada</p>
                  </div>
                </template>
              </b-table>
            </div>
          </b-card-body>
        </b-card>
      </transition>
      <!-- Modal Component -->
      <b-modal
        v-model="modal.visible"
        :title="modal.title"
        ok-title="Salvar"
        cancel-title="Cancelar"
        :ok-disabled="!validateState('value')"
        @ok="onModalSave"
      >
        <b-form-group label="Valor">
          <b-form-input
            v-model="modal.value"
            v-validate="'required'"
            type="text"
            class="form-control"
            aria-describedby="invalidValue"
            name="value"
            :state="validateState('value')"
          ></b-form-input>
          <b-form-invalid-feedback id="invalidValue">
            {{ errors.first("value") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import {
  getResponses,
  createResponse,
  editResponse,
  deleteResponse,
} from "../../api/company";

export default {
  name: "ResponseList",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { key: "id", label: "ID" },
        {
          key: "text",
          label: "Texto",
        },
        {
          key: "actions",
          label: "Ações",
        },
      ],
      modal: {
        visible: false,
        id: null,
        value: null,
      },
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    rowClass() {
      return "response-row";
    },

    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    edit(item) {
      this.modal.title = "Editar";
      this.modal.id = item._id;
      this.modal.value = item.text;
      this.modal.visible = true;
    },

    async remove(item) {
      try {
        await deleteResponse(this.id, item._id);
        this.$refs.table.refresh();
      } catch (e) {
        this.$bvToast.toast(e.response.data, {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      }
    },

    onNewResponseClicked() {
      this.modal.title = "Adicionar";
      this.modal.id = null;
      this.modal.value = null;
      this.modal.visible = true;
    },

    async retrieveData() {
      const response = await getResponses(this.id);
      return response.data;
    },
    async onModalSave() {
      try {
        if (this.modal.id) {
          await editResponse(this.id, this.modal.id, {
            text: this.modal.value,
          });
          this.$bvToast.toast("Resposta editada com sucesso!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            variant: "light",
            solid: true,
            autoHideDelay: 5000,
            noCloseButton: false,
          });
        } else {
          await createResponse(this.id, {
            text: this.modal.value,
          });
          this.$bvToast.toast("Resposta criada com sucesso!", {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            variant: "light",
            solid: true,
            autoHideDelay: 5000,
            noCloseButton: false,
          });
        }
        this.$refs.table.refresh();
      } catch (error) {
        console.log(error);
        if (error.response.status === 403) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.filters-section {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  align-items: flex-end;
}

.action-button {
  flex-basis: 150px;
}

.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

::v-deep .responses-header th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
  border: 0;
  white-space: nowrap;
}

::v-deep .response-row {
  cursor: pointer;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s ease-in-out;
}

::v-deep .response-row:hover {
  background-color: #e9ecef !important;
}

::v-deep tbody tr:last-of-type {
  border-bottom: none;
}

::v-deep .response-row td {
  border-top: none;
  vertical-align: middle;
  padding: 0.85rem 0.75rem;
}

::v-deep .id-text {
  color: #6c757d;
  font-size: 0.9rem;
}

::v-deep .text-content {
  color: #495057;
  font-weight: 500;
}

::v-deep .action-icon {
  color: #6c757d;
  transition: color 0.2s;
}

::v-deep .response-row:hover .action-icon {
  color: #007bff;
}

::v-deep .action-button-icon {
  padding: 0.25rem 0.5rem;
}
</style>
